import React = require('react');
import {ProfileItemComp} from "./ProfileItemComp";
import {IProileComp, IProfileCompData} from "../../interfaces/layout/blocks/IUser";

interface IConnectedPeopleCompProps {
	enabledAddNew:boolean;
    label:string;
    type:string;
    activeClass:string;
    changeTypeHandler:Function;
    getData:Function;
    connnectedPeople:Array<IProileComp>
}

interface IConnectedPeopleCompState {
}

export default class ToggleBtnConnectedPeopleComp extends React.Component<IConnectedPeopleCompProps, IConnectedPeopleCompState>{

    constructor(props:IConnectedPeopleCompProps){
        super(props);
    }

    private profileClickHandler(evt, id:number): void {
        evt.preventDefault();
        this.props.getData(id);
    }

    render() {
        var className:string = 'connectedPeopleComp ' + this.props.type;
        return (
            <div className={ className }>
                <h2>
                    { this.props.enabledAddNew===true?<a className={ this.props.activeClass } onClick = { e => this.props.changeTypeHandler(e, 'children') }> <span className="add_new_icon"></span> <span className="text">{ this.props.label}</span></a>:''}
                </h2>
                <div className="childrens">
                    { this.props.connnectedPeople.map((item:IProileComp, key) => {
                        return <ProfileItemComp key={key} id={ item.id } name={ item.name } birthDate={ item.birthDate } birthName={ item.birthName } deathDate={ item.deathDate } city={ item.city} affinity={ item.affinity } img={ item.img } motherName={ item.motherName } fatherName={ item.fatherName } motherId={ item.motherId } fatherId={ item.fatherId } affinityGroup={ item.affinityGroup } currentUser={ item.currentUser } onClick={ e => this.profileClickHandler(e, item.id) } />
                    })}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/ConnectedPeopleComp.tsx